module.exports = __webpack_public_path__ + "img/dashboard.1eb06aa6.svg";